<template>
  <div>
    <div class="chart-table">
      <div class="chart-table-head">
        <span class="chart-table-cell cell-6">地址</span> <span class="chart-table-cell cell-4">备注</span>
      </div>
      <div class="chart-table-body">
        <div v-for="(item, i) in company.面试地址" :key="i" class="chart-table-row">
          <span class="chart-table-cell cell-6">{{ item.地址 || '' }}</span>
          <span class="chart-table-cell cell-4">{{ item.备注 || '' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => {} },
  },
}
</script>
<style src="../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
